import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#0A0A0A] py-16 border-t border-gold/20" data-id="element-36">
      <div className="max-w-6xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-37">
        <h2 className="font-serif text-xl text-gold tracking-[0.4em] uppercase font-light mb-8" data-id="element-38">
          FLA
        </h2>

        <p className="font-sans font-light text-offwhite/40 text-xs tracking-widest uppercase mb-4" data-id="element-39">
          © {new Date().getFullYear()} FLA Estilista Capilar
        </p>

        <a href="#" className="text-gold/70 hover:text-gold transition-colors text-xs font-sans tracking-widest uppercase" data-id="element-40">
          Instagram
        </a>
      </div>
    </footer>;
};